import o from"next/head";import t from"react";import n from"./serialize-json-ld.js";function r(e){return t.createElement(o,null,t.createElement("script",{type:"application/ld+json",dangerouslySetInnerHTML:{__html:n(e)}}))}r.defaultProps={};export{r as ProductData};
//# sourceMappingURL=index.js.map
